import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-input-string',
  templateUrl: './input-string.component.html',
  styleUrls: ['./input-string.component.less'],
})
export class InputStringComponent extends Field {
  @ViewChild('input') input: ElementRef;

  isLink = false;

  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  initField() {
    if (this.recordProperty !== undefined && this.recordProperty.InTable) {
      setTimeout(() => {
        this.input.nativeElement.focus();
      }, 100);
    }

    this.isLink = this.validURL(this.recordProperty.ValueAsObject);
  }

  OpenURL(url) {
    window.open(url);
  }

  validURL(str) {
    if (this.field.AdditionalInformationParsed.IsLink) {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      ); // fragment locator
      return !!pattern.test(str);
    } else {
      return false;
    }
  }
}
